import React from 'react';
import { observer } from 'mobx-react';
import { YesNoViewTemplate } from 'themes/components';

function YesNoView(props) {
	return <YesNoViewTemplate {...props} />;
}

export default observer(YesNoView);
